import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './styles.css';
import { App } from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { initErrorReporter } from './lib/errorReporter';

const baseUrl = (import.meta.env.VITE_MELA_API_URL ?? '').trim();
const anonKey = (import.meta.env.VITE_SUPABASE_ANON_KEY ?? '').trim() || undefined;

if (baseUrl) {
  initErrorReporter({
    baseUrl,
    anonKey,
    // Vite injects a build-time __BUILD__ when defined — we don't define one,
    // so this stays undefined and the report just omits it.
    build: undefined,
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </BrowserRouter>
  </React.StrictMode>
);
